import { initializeApp } from "firebase/app";
import {
  Auth,
  browserLocalPersistence,
  browserSessionPersistence,
  getAuth,
  indexedDBLocalPersistence,
  initializeAuth,
} from "firebase/auth";
import { FirebaseApp } from "firebase/app";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET as string,
  messagingSenderId: import.meta.env
    .VITE_FIREBASE_MESSAGING_SENDER_ID as string,
  appId: import.meta.env.VITE_FIREBASE_APP_ID as string,
};

const app: FirebaseApp = initializeApp(firebaseConfig);
// initializeAuth without a popupRedirectResolver, NOT getAuth(): getAuth()
// installs the browser popup/redirect resolver, and on iOS, Safari and mobile
// browsers Firebase then initialises it "proactively" BEFORE it restores the
// stored user — loading https://apis.google.com/js/api.js (a script tag with
// no timeout), waiting up to 30–60 s for gapi.iframes, and opening an auth
// iframe on the authDomain with a 5–15 s ping timeout. authStateReady() does
// not resolve until all of that settles, so on a slow phone connection the
// auth bootstrap sat on "Loading..." past the 30 s watchdog (2026-10-06: 42
// "Auth bootstrap stalled" reports/day, all iPhone, all on /callback). This app
// signs in with custom tokens only — no signInWithPopup/Redirect — so the
// resolver did nothing for us. The persistence chain is getAuth()'s exact
// default (@firebase/auth 1.10.8): IndexedDB, then localStorage, then
// sessionStorage for a webview that blocks both — never in-memory.
const createAuth = (): Auth => {
  try {
    return initializeAuth(app, {
      persistence: [
        indexedDBLocalPersistence,
        browserLocalPersistence,
        browserSessionPersistence,
      ],
    });
  } catch {
    // auth/already-initialized (HMR re-evaluated this module): reuse it.
    return getAuth(app);
  }
};
const auth: Auth = createAuth();

// Firestore and Storage are deliberately NOT initialised here: this module is
// imported by AuthContext, so everything it pulls in ships in the boot chunks
// (Firestore alone is ~1 MB of source). The pages that need them import
// ./firebase-firestore and ./firebase-storage instead.
export { app, auth };
